<template>
  <div class="summary">
    <h2 class="h2">Összesítő</h2>
    <p>
      Kérlek, nézd át az összesítőt. Az elemekre kattintva változtathatsz
      válaszaidon!
    </p>
    <div class="container">
      <div class="steps">
        <Step
          v-for="(step, i) in steps"
          :index="i"
          :title="step.title"
          :path="step.data.slug"
          :noanswer="!answers[i]"
          :answer="answerValue(i)"
          :unit="unitValue(i)"
          :key="step.data.slug"
        />
      </div>
      <form action="" class="form-container" ref="form">
        <div class="form-row">
          <div class="form-label">
            <label :for="'personal-name-' + id" class="required">Név</label>
          </div>
          <div class="form-control">
            <input
              type="text"
              v-model="personal.name"
              @change="changeValue"
              name="name"
              :id="'personal-name-' + id"
              required="required"
              placeholder="A teljes neved"
            />
          </div>
          <div class="form-error"></div>
        </div>
        <div class="form-row">
          <div class="form-label">
            <label :for="'personal-email-' + id" class="required">E-mail</label>
          </div>
          <div class="form-control">
            <input
              type="email"
              v-model="personal.email"
              @change="changeValue"
              name="email"
              :id="'personal-email-' + id"
              required="required"
              placeholder="Az e-mail címed"
            />
          </div>
          <div class="form-error"></div>
        </div>
        <div class="form-row">
          <div class="form-label">
            <label :for="'personal-phone-' + id">Telefonszám</label>
          </div>
          <div class="form-control">
            <input
              type="tel"
              v-model="personal.phone"
              @change="changeValue"
              name="phone"
              pattern="^[0-9+-/]*$"
              :id="'personal-phone-' + id"
              placeholder="+36 30 666 66 66"
            />
          </div>
          <div class="form-error"></div>
        </div>
        <button class="hidden" ref="submit" type="submit"></button>
      </form>
    </div>
    <div class="controls">
      <Button
        :to="{ path: '/kerdoiv/' + steps[steps.length - 1].data.slug }"
        arrow="left"
        class="white"
      ></Button>
      <Button @click.native="click" arrow="right" class="black"
        >Válaszok elküldése</Button
      >
    </div>
  </div>
</template>

<script>
import Step from "@/components/Step.vue";
import Button from "@/components/inputs/Button.vue";
import axios from "axios";
import { Validate } from "@/validate.js";

export default {
  name: "Summary",
  components: {
    Step,
    Button
  },
  data() {
    return {
      personal: this.value || {
        name: "",
        email: "",
        phone: ""
      },
      id: "start"
    };
  },
  computed: {
    // personal() {
    //   return this.$store.getters.getPersonal;
    // },
    steps() {
      return this.$store.getters.getSteps;
    },
    answers() {
      return this.$store.getters.getAnswers;
    },
    isEmpty() {
      return (
        this.personal.name == "" ||
        this.personal.email == "" /* ||
        this.personal.phone == "" */
      );
    }
  },
  mounted() {
    const messages = this.$store.getters.getMessages;
    Validate(this.$refs.form, {
      submit: e => {
        // console.log(e);
        e.preventDefault();
        this.send();
      },
      messages: messages
    });
  },
  methods: {
    changeValue() {
      // console.log("e: ", e);
      // this.validate(e.target);
      this.$store.commit("setPersonal", this.personal);
    },
    answerValue(i) {
      const a = this.answers[i];
      if (typeof a === "string")
        return this.steps[i].data.items.find(item => item.key === a).label;
      if (a instanceof Array) return "+" + a.length;
      if (a instanceof Object) return a[a.type];
      return a;
    },
    unitValue(i) {
      if (this.steps[i].data.unit !== undefined) {
        return this.steps[i].data.unit;
      }
      const a = this.answers[i];
      if (a instanceof Object) {
        return this.steps[i].data.items[a.type].unit;
      }
      return null;
    },
    /* back() {
      this.$router.push(
        "/kerdoiv/" + this.steps[this.steps.length - 1].data.name
      );
    }, */
    click() {
      this.$refs.submit.click();
    },
    async send() {
      if (!this.personal.name && !this.personal.email) {
        this.$router.push("/kerdoiv/start");
        return;
      }

      try {
        await axios.post("questionnaire", {
          personal: this.personal,
          answers: this.answers
        });
        this.$store.commit("setAnswers", []);
        this.$store.commit("setPersonal", {});
        this.$router.push("/kerdoiv/koszonjuk");
      } catch (e) {
        this.$router.push("/kerdoiv/hiba");
      }

      //this.$store.commit("setAnswers", []);
      //this.$store.commit("setPersonal", {});

      // localStorage.removeItem("answers");
      // localStorage.removeItem("personal");
    }
  }
  /* mounted() {
    this.personal = this.$store.getters.getPersonal;
    this.steps = this.$store.getters.getSteps;
    this.answers = this.$store.getters.getAnswers;
  }, */
};
</script>

<style lang="scss">
.summary {
  display: flex;
  flex-direction: column;
  padding: 64px 16px 16px;
  box-sizing: border-box;
  height: 100%;
  > p {
    margin: 8px 0;
  }
  .container {
    //height: 100%;
    padding: 32px 32px 32px 0;
    display: flex;
    gap: 30px;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .steps {
      display: flex;
      flex-wrap: wrap;
      max-width: 26rem;
      .step {
        margin: 0.2rem 0.2rem 0.2rem 0;
      }
    }
  }
  .controls {
    display: flex;
    width: 100%;
    flex: 0 0 5%;
    justify-content: space-between;
  }

  @media screen and (min-width: $breakpoint) {
    padding: 24px;
    .container {
      padding: 32px;
      flex-direction: row;
      .steps {
        .step {
          margin: 0.2rem;
        }
      }
    }
  }
}
</style>
